import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b046526e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-bar center" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"progress-bar__wrap\" data-v-b046526e><span class=\"progress-bar__wrap-line\" data-v-b046526e><span class=\"blue\" data-v-b046526e></span><span class=\"green\" data-v-b046526e></span><span class=\"yellow\" data-v-b046526e></span><span class=\"orange\" data-v-b046526e></span><span class=\"darkOrange\" data-v-b046526e></span></span></div>", 1)

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseProgressBar',
  props: {
    rating: {},
    maxRate: { default: 100 },
    size: {}
  },
  setup(__props: any) {

const props = __props;

const percentRating = computed((): number => {
  return (props.rating / props.maxRate) * 100;
});
const ratingText = computed((): string => {
  if (props.rating <= props.maxRate / 5) {
    return 'Эконом';
  }
  if (props.rating <= (props.maxRate / 5) * 2) {
    return 'Комфорт';
  }
  if (props.rating <= (props.maxRate / 5) * 3) {
    return 'Бизнес';
  }
  if (props.rating <= (props.maxRate / 5) * 4) {
    return 'Премиум';
  }

  return 'Элит';
});

return (_ctx: any,_cache: any) => {
  const _component_base_rating_number = _resolveComponent("base-rating-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", {
      style: _normalizeStyle({
        left: `calc(${_ctx.rating > _ctx.maxRate ? 100 : percentRating.value}% - 13px)`,
      }),
      class: "progress-bar__rating"
    }, [
      _createVNode(_component_base_rating_number, {
        maxRate: _ctx.maxRate,
        rating: _ctx.rating
      }, null, 8, ["maxRate", "rating"])
    ], 4),
    _createElementVNode("span", {
      class: _normalizeClass([[_ctx.rating >= _ctx.maxRate / 2 ? 'left' : 'right'], "progress-bar__caption"]),
      style: _normalizeStyle(
        _ctx.rating >= _ctx.maxRate / 2
          ? {
              width: `calc(${_ctx.rating > _ctx.maxRate ? 100 : percentRating.value}% - 25px)`,
            }
          : {
              left: `calc(${percentRating.value}% + 20px)`,
              width: `calc(${100 - percentRating.value}% - 40px)`,
            }
      )
    }, null, 6),
    _createElementVNode("span", {
      class: _normalizeClass([[_ctx.rating >= _ctx.maxRate / 2 ? 'left' : 'right'], "progress-bar__caption-text"])
    }, _toDisplayString(ratingText.value), 3)
  ]))
}
}

})